import Module from './Module'
import { ASSETS } from '../config/config'

type GroupedModule = {
  groupName: string;
  modules: Module[];
}

export default class ModuleUtils {
  public static buildModule(name: string, category: string): Module {
    const data = (ASSETS as any)[category].data.find((e: any) => e.name === name)
    return new Module(category, name, `./assets/${category}/${name}.svg`, data.title, data.description)
  }

  public static moduleExists(name: string, category: string): boolean {
    return category in ASSETS && (ASSETS as any)[category].data.some((e: any) => e.name === name)
  }

  public static getModules(): GroupedModule[] {
    const groupedModules: GroupedModule[] = []
    Object.entries(ASSETS).forEach(([key, value]) => {
      const modules: Module[] = []
      value.data.forEach(svgModule => {
        modules.push(new Module(key, svgModule.name, `./assets/${key}/${svgModule.name}.svg`, svgModule.title, svgModule.description))
      })
      groupedModules.push({ modules, groupName: value.name })
    })
    return groupedModules
  }
}
